module.exports = {"APP_NAME":"Tab","TOTAL_TAB_SALES":"Total Tab Sales","ENTER":"Enter"}


//////////////////
// WEBPACK FOOTER
// ./src/app/locale/en/startPage.json
// module id = 345
// module chunks = 8